import {Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import React from "react";


const DefaultModal = ({modal, toggle, select, children,handleSubmit, classes, headerColor, showFooterBtns = true, header = 'Selecteer hieronder de gewenste oplossing:'}, ...props)=> {
    return (
        <Modal isOpen={modal} toggle={toggle} className={classes} style={{borderRadius: '40px !important'}}>
            <ModalHeader toggle={toggle} className={headerColor}>{header}</ModalHeader>

            <ModalBody>
                {children}
            </ModalBody>
            <ModalFooter>
                {showFooterBtns &&
                    <>
                        <Button  onClick={toggle} outline className="me-2 btn-outline btn-color-style custom-btn-padding" type="button" color="secondary">
                            Scherm sluiten
                        </Button>
                        <Button  onClick={handleSubmit} outline className="me-2 btn-outline btn-color-style custom-btn-padding" type="button" color="secondary">
                            Toepassen
                        </Button>
                    </>
                }
            </ModalFooter>
        </Modal>
    )
}

export default DefaultModal;
